export const INACTIVE = "INACTIVE";

export const EDIT_SPLIT_TRANSACTION = "EDIT_SPLIT_TRANSACTION";
export const DELETE_SPLIT_TRANSACTION = "DELETE_SPLIT_TRANSACTION";
